export class ChartDataModel {
  data: [];
  display: boolean;
  name: string;
  amount: number;
  firstLabel: string;
  secondLabel: string;
  constructor(firstLabel, secondLabel, name, amount?, display?, data?) {
    this.firstLabel = firstLabel;
    this.secondLabel = secondLabel;
    this.name = name;
    if (amount == undefined) {
      amount = 0;
    }
    if (display == undefined) {
      display = false;
    }
    if (data == undefined) {
      data = [];
    }
  }
}
